import { StatusType } from "../../types";

export const STATUS_COLORS: Array<
  StatusType & { conditional?: "approvalFlow" | "additionalStatuses" }
> = [
  { label: "Warning", color: "#DD1515" },
  { label: "Emissions Included", color: "#9EE766" },
  { label: "Reviewed", color: "#00A1FF", conditional: "approvalFlow" },
  { label: "Approved (Signed Off)", color: "#0E25D5" },
  { label: "Approved (Locked)", color: "#1D1D1D" },
  {
    label: "Not Applicable",
    color: "#7F7F7F",
    conditional: "additionalStatuses",
  },
];
